import {api} from '../../helpers';
import {getCookieValue} from '../../helpers/getCookie';

const env = getCookieValue('env');
const environment = env === 'Production' ? 'live' : env;

function setUp2FA() {
  return api.post(`/users/2fa/setup`).then(res => res.data);
}

function verify2FA(data) {
  return api.post(`/users/2fa/verify`, data).then(res => res.data);
}

function remove2FA(data) {
  return api.post(`/users/2fa/remove`, data).then(res => res.data);
}

function fetchNotificationEmails(params) {
  return api
    .get(`/users/company/email-notification`, {
      params: {
        environment: environment?.toLowerCase() || 'sandbox',
        ...params,
      },
    })
    .then(res => res.data);
}

function addNotificationEmails(data) {
  return api
    .post(`/users/company/email-notification`, data)
    .then(res => res.data);
}

function deleteNotificationEmail(roleId) {
  return api
    .delete(`/users/company/email-notification/${roleId}`)
    .then(res => res.data);
}

export {
  setUp2FA,
  verify2FA,
  remove2FA,
  fetchNotificationEmails,
  addNotificationEmails,
  deleteNotificationEmail,
};
